import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { firestore } from '../../../../../../contexts/FirebaseContext';
import useAuthUsers from '../../../../../../hooks/useAuthUsers';
import HistorialEmpaqueList from './HistorialEmpaqueList';

export default function DialogHistorialEmpaque({ open, onClose, dataUser }) {
  const [dataHistorial, setDataHistorial] = useState([]);

  const handleClose = () => {
    onClose(false);
  };

  console.log(dataHistorial);

  useEffect(() => {
    async function getData() {
      await firestore
        .collection('empaque_historial')
        .where('almacendId', '==', dataUser.almacenId)
        .orderBy('createdAt', 'desc')
        .onSnapshot((queryS) => {
          const dat = [];
          queryS.forEach((doc) => {
            dat.push({
              id: doc.id,
              ...doc.data()
            });
          });
          // console.log('datos del user', dat);
          setDataHistorial(dat);
        });
    }

    if (dataUser.almacenId) {
      getData();
    }
  }, [dataUser.almacenId]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xl"
      fullWidth
    >
      {/* <DialogTitle sx={{ textAlign: 'center' }} id="alert-dialog-title">
          Wallet del usuario
        </DialogTitle> */}
      <DialogContent>
        <HistorialEmpaqueList dataTable={dataHistorial} />
        {/* <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <UserWallet userId={userData.id} />
          </Grid>
          <Grid item xs={12} md={8}>
            <PaymentReports transactions={transactions} />
          </Grid>
        </Grid> */}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
